// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { patchGeofence } from '../../services/GeofencesService';
import { Geofence, PatchGeofenceRequest } from '../../types/Geofences';

type Result = UseMutationResult<Geofence, Error, PatchGeofenceRequest>;

type ErrorResponse = {
  statusCode: number;
  message: string;
  error: string;
};

function usePatchGeofence(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchGeofence, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['geofences'] });
    },
    onError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>;
      const errorMessage = axiosError.response?.data?.message ?? axiosError.message ?? 'Something went wrong';

      failureCb(errorMessage);
    },
  });
}

export default usePatchGeofence;
